import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LeerTcComponent } from "./leer-tc/leer-tc.component";

const routes: Routes = [
  {
    path: ":tipo/terminos-y-condiciones",
    pathMatch: "full",
    component: LeerTcComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedRoutingModule {}
